import { createJsonbObjectEditor } from "../_resources/jsonbObjectEditor.js";
import { createJsonbTableEditor } from "../_resources/jsonbTableEditor.js";

export default function ({ dom, message, filePicker }) {

  const render = (pageId, base_url, hasPageEditAccess) => {
    dom.html("");
    const domLogo = dom.append("section").class("componentsview-logo-editor");
    const domHowto = dom.append("section").class("componentsview-howto-editor");
    const domFooter = dom.append("section").class("componentsview-footer-editor");
    const domSeeAlso = dom.append("section").class("componentsview-seealso-editor");
    const domUserLogin = dom.append("section").class("componentsview-userlogin-editor");
    const domVideoBlock = dom.append("section").class("componentsview-videoblock-editor");
    const domSocialButtons = dom.append("section").class("componentsview-socialbuttons-editor");

    createJsonbObjectEditor({
      dom: domLogo, message, heading: "Logo", table: 'pages', recordId: pageId, fieldName: 'theme_components', base_url, subPath: 'Logo',
      schema: {
        "url": { type: "url", label: 'Link' }, 
        "text": { type: "text", label: '文 Text', comment: "set directly here or use a translated 文 Text"},
        "image": { type: "image", label: 'Image', comment: `uploaded file, global https url or asset/path or ICON_ID from a<a href="https://github.com/Gapminder/tools-page/blob/main/src/app/core/icons.js">known list</a>`},
        "style": { type: 'kvp', label: 'Style', keys: ['letter-spacing'], comment: ["example: 0.05em"] },
        "resetStateOnClick": { type: "boolean", label: 'Click to reset' }
      },
      allowEdit: hasPageEditAccess,
      filePicker
    }).load();

    createJsonbObjectEditor({
      dom: domHowto, message, heading: "Howto (remind angie to add support for howto links)", table: 'pages', recordId: pageId, fieldName: 'theme_components', base_url, subPath: 'Howto',
      schema: {
        //"links": [ {"url": "assets/guide.pdf", "text": "pdf_guide"}, {"url": "https://vizabi.com","text": "can_i_show_my_own_data"} ],
        "videoUrl": {type: "url", label: "Youtube or Vimeo URL"},
      },
      allowEdit: hasPageEditAccess,
      filePicker
    }).load();

    createJsonbObjectEditor({
      dom: domFooter, message, heading: "Footer", table: 'pages', recordId: pageId, fieldName: 'theme_components', base_url, subPath: 'Footer',
      schema: {
        "heading": {type: "text", label: "文 Heading", comment: "set directly here or use a translated 文 Text"},
        "caption": {type: "text", label: "文 Caption", comment: "set directly here or use a translated 文 Text"},
        "style": { type: 'kvp', label: 'Style', keys: ['display'], comment: ["flex, block or none"] },
      },
      allowEdit: hasPageEditAccess,
      filePicker
    }).load();

    createJsonbObjectEditor({
      dom: domSeeAlso, message, heading: "See-also ribbon", table: 'pages', recordId: pageId, fieldName: 'theme_components', base_url, subPath: 'SeeAlso',
      comment: "set display to 'none' (default) to hide the block, 'flex' to show it",
      schema: {
        "style": { type: 'kvp', label: 'Style', keys: ['display', "justify-content"], comment: ["flex or none", "possible values: center, start, end, space-around, space-between, space-evenly"] },
      },
      allowEdit: hasPageEditAccess,
      filePicker
    }).load();

    createJsonbObjectEditor({
      dom: domUserLogin, message, heading: "User login button", table: 'pages', recordId: pageId, fieldName: 'theme_components', base_url, subPath: 'UserLogin',
      comment: "set display to 'none' (default) to hide the block, 'flex' to show it",
      schema: {
        "style": { type: 'kvp', label: 'Style', keys: ['display'], comment: ["block or none"] },
      },
      allowEdit: hasPageEditAccess,
      filePicker
    }).load();

    createJsonbObjectEditor({
      dom: domVideoBlock, message, heading: "Video block", table: 'pages', recordId: pageId, fieldName: 'theme_components', base_url, subPath: 'VideoBlock',
      comment: "note: to hide the video block, set display to 'block' in general styles for .too-related-items",
      schema: {
        "videoUrl": { type: "url", label: 'Youtube or Vimeo URL' }, 
        "text": { type: "text", label: '文 Heading', comment: "set directly here or use a translated 文 Text"},
        "title": { type: "text", label: 'Tooltip text' },
        "placeholderImageUrl": { type: "image", label: 'Placeholder image', comment: `uploaded file, global https url or asset/path`},
        
      },
      allowEdit: hasPageEditAccess,
      filePicker
    }).load();

    createJsonbObjectEditor({
      dom: domSocialButtons, message, heading: "Social buttons", table: 'pages', recordId: pageId, fieldName: 'theme_components', base_url, subPath: 'SocialButtons',
      schema: {
        "title": { type: "text", label: 'Email subject' }
      },
      allowEdit: hasPageEditAccess,
      filePicker
    }).load();
  };

  return { render };
}

